/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './findRelatedAccounts.defs.js'
export * as $defs from './findRelatedAccounts.defs.js'
